import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PermataSnapInquiryComponent} from './permata-snap-inquiry/permata-snap-inquiry.component';
import {PermataSnapPaymentComponent} from './permata-snap-payment/permata-snap-payment.component';
import {PermataSnapPaymentResultComponent} from './permata-snap-payment-result/permata-snap-payment-result.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SharedComponentModule} from '@shared/component/shared-component.module';
import {DirectiveModule} from '@shared/directive/directive.module';


@NgModule({
  declarations: [PermataSnapInquiryComponent, PermataSnapPaymentComponent, PermataSnapPaymentResultComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedComponentModule,
    FormsModule,
    DirectiveModule
  ]
})
export class PermataSnapModule { }
